import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { DropdownWithSearch, TextInput, Image } from "hesus-ui-kit";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import { TABLE_SELLING_PRICE_LIST_ENDPOINT } from "@utils/constants";
import { loadAllSellingPrices } from "./SellingPricesList.actionCreators";
import { setAllSellingPricesLoadingState } from "./SellingPricesList.slice";
import { searchInputStyles } from "@utils/extra-style";
import EnquirySellingPrice from "./components/EnquirySellingPrice";
import {
  OuterWrapper,
  FlexRow,
  FilterFlexRow,
  SectionContainer,
  GridRow,
  FilterOuter,
  GlobalSearch,
  ButtonWrapper,
  CreateButton,
} from "./SellingPricesList.styled";
import "./SellingPricesList.scss";

const ViewData = (props) => {
  const {
    t,
    isRefreshList,
    updateRefeshStatus,
    requestId,
    transportTypes,
    enquiryData,
    createNewAction,
    page,
    selectedSolutionIds,
    setSelectedSolutionIds,
    countryId,
  } = props;

  const [data, setData] = useState([]);
  const [tranportTypeFilterValue, setTranportTypeFilterValue] = useState([]);
  const [activeStatus, setActiveStatus] = useState(1);
  const [isRefreshDataAgain, setRefreshState] = useState(false);

  const [search, setSearch] = useState("");
  const [sort, setSortOption] = useState({ dir: "desc", column: "id" });
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState({});
  const dataURL = TABLE_SELLING_PRICE_LIST_ENDPOINT;
  const dispatch = useDispatch();

  const refreshData = (data) => {
    setRefreshState(data);
  };

  const sellingPricesListByIds = useSelector(
    (state) => state.sellingPricesList.byId
  );
  const sellingPricesListAllIds = useSelector(
    (state) => state.sellingPricesList.allIds
  );
  const filteredRecords = useSelector(
    (state) => state.companyList.filteredRecords
  );

  /**
   * Method to fetch set of records based on the filters applied.
   * @param {pageSize} pageSize
   * @param {pageStart} pageStart
   * @param {globalFilter} globalFilter
   * @param {sort} sort
   * @param {appliedFilters} appliedFilters
   */
  const fetchRecords = ({
    search,
    sort,
    tranportTypeFilterValue,
    activeStatus,
  }) => {
    // save request data,
    setRequestData({
      search,
      sort,
      tranportTypeFilterValue,
      activeStatus,
    });

    let transports = [];
    tranportTypeFilterValue.map((item) => {
      item.value !== "*" && transports.push(item.value);
    });
    setLoading(true);

    dispatch(setAllSellingPricesLoadingState());
    dispatch(
      loadAllSellingPrices({
        dataURL,
        requestId,
        sort,
        search,
        status: 1,
        transports,
        activeStatus,
        countryId,
      })
    );
  };

  useEffect(() => {
    if (isRefreshDataAgain) {
      setRefreshState(false);
    }
    if (isRefreshList) {
      setRefreshState(true);
    }
  }, [isRefreshDataAgain, isRefreshList]);

  useEffect(() => {
    if (!loading) {
      fetchRecords({
        search,
        sort,
        tranportTypeFilterValue,
        activeStatus,
      });
    }
  }, [isRefreshDataAgain, tranportTypeFilterValue, search, activeStatus]);

  useEffect(() => {
    if (sellingPricesListAllIds.length > 0) {
      const responseData = sellingPricesListAllIds.map((id) => {
        const tempData = { ...sellingPricesListByIds[id] };
        return tempData;
      });
      setData([...responseData]);
      if (parseInt(responseData[0]?.requestId) === parseInt(requestId, 10))
        setLoading(false);
    } else {
      setData([]);
      setLoading(false);
    }
  }, [t, sellingPricesListAllIds, sellingPricesListByIds, filteredRecords]);

  const onTransportTypeFilterChange = (transports) => {
    setTranportTypeFilterValue(transports);
  };

  const globalSearchFilter = (e) => {
    setSearch(e.target.value);
  };

  const changeStatus = () => {
    setActiveStatus(activeStatus === 1 ? 2 : 1);
  };

  useEffect(() => {
    const solutionIds = [];
    data.map((selectedSellingPrice) => {
      solutionIds[selectedSellingPrice.id] = [];
      selectedSellingPrice.services.map((service) => {
        solutionIds[selectedSellingPrice.id][
          parseInt(service.hesusService.id, 10)
        ] = [];
        service.solutions.map((solutionInfo) => {
          solutionIds[selectedSellingPrice.id][
            parseInt(service.hesusService.id, 10)
          ].push(solutionInfo.solution.id);
        });
      });
    });
    setSelectedSolutionIds(solutionIds);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <OuterWrapper>
      <FlexRow>
        <SectionContainer>
          <div>
            <FilterFlexRow>
              {page === "enquiryView" && (
                <>
                  <FilterOuter>
                    <div className="selling-price-list__filters-wrapper">
                      <Image
                        src={activeStatus === 1 ? enableIcon : disableIcon}
                        alt={t("SELLING_PRICE_FILTER_ACTIVE_ONLY")}
                        title={t("SELLING_PRICE_FILTER_ACTIVE_ONLY")}
                        className="selling-price-list__image-icon"
                        onClick={changeStatus}
                      />
                      <label className="label selling-price-list__active-label">
                        {t("SELLING_PRICE_FILTER_ACTIVE_ONLY")}
                      </label>
                    </div>
                    <DropdownWithSearch
                      label={t("SELLING_PRICE_FILTER_TRANSPORTS")}
                      placeholder={t("SEARCH")}
                      name="transport-types"
                      labelClass="selling-price-list__admins-list-label"
                      containerClass="selling-price-list__admins-list-dropdown-container"
                      value={tranportTypeFilterValue || ""}
                      defaultOption="Nothing Selected"
                      options={transportTypes}
                      onChange={onTransportTypeFilterChange}
                      containerStyles={{
                        minWidth: "12rem",
                        marginBottom: "20px",
                      }}
                    />
                  </FilterOuter>
                  <GlobalSearch>
                    <div className="search-box">
                      <TextInput
                        id="selling-price-list-search"
                        type="search"
                        name="global-filter"
                        inputClass="search-box-default-input"
                        value={search || ""}
                        onChange={(e) => globalSearchFilter(e)}
                        placeholder=""
                        inputStyles={searchInputStyles}
                      />
                    </div>
                  </GlobalSearch>
                </>
              )}

              <ButtonWrapper>
                <CreateButton onClick={createNewAction}>{`${t(
                  "ACTION_NEW_SELLING_PRICE"
                )}`}</CreateButton>
              </ButtonWrapper>
            </FilterFlexRow>
          </div>
          <div>
            <GridRow>
              <EnquirySellingPrice
                sellingPriceData={data}
                onRefreshData={refreshData}
                enquiryData={enquiryData}
                updateRefeshStatus={updateRefeshStatus}
                page={page}
                loading={loading}
                requestId={requestId}
                selectedSolutionIds={selectedSolutionIds}
              />
            </GridRow>
          </div>
        </SectionContainer>
      </FlexRow>
    </OuterWrapper>
  );
};

ViewData.propTypes = {
  t: PropTypes.func.isRequired,
  isRefreshList: PropTypes.bool.isRequired,
  page: PropTypes.string,
};

ViewData.defaultProps = {};

export default withTranslation()(ViewData);
